/**
 * Chat Section Components - Schema-driven rendering for Chat tab
 *
 * Each component handles one CHAT_SCHEMA section type.
 * Used by ChatSectionRenderer to dispatch based on config.type.
 */

export { MessagesSection } from './messages-section';
export { WhatsAppSendSection } from './whatsapp-send-section';
export { ChatterPostSection } from './chatter-post-section';
export { MessengerTabsSection } from './messenger-tabs-section';
